import {writable} from "svelte/store";
import {API_URL} from "../../env";
import updateUserData from "./updateUserData";

fetch(API_URL + '/shoppingCart', {
    method: 'GET',
    credentials: "include",
}).then(async (data) => {
    if (!data.ok) return console.log(await data.json());

    let cartItems = await data.json()

    // shoppingCart.set(cartItems)

    let ids = cartItems.map(v => v.product_id);

    // Second fetch => fetching products info
    const res = await fetch(API_URL + '/products/' + ids.join(','))

    if (!res.ok) return console.log(await res.json());

    let products = await res.json()

    cartItems.forEach(element => {
        element.product = products.find(v => v.id === element.product_id)
    })

    shoppingCart.set(cartItems)
})


export const shoppingCart = writable([])
export const showShoppingCart = writable(false)
// export const deviceWidth = writable(0)
export const filter = writable("")
export const order = writable(null)
// export const order = writable({})
// export const order = writable({
//     order_id: "69",
//     name: "Al",
//     surname: "Mualim",
//     email: "alik@mualim.cz",
//     phone: "+420 156 895 263",
//     country: "Česká republika",
//     street: "Pražská 1203",
//     city: "Náchod",
//     zip: "54701",
//     billing_country: "Slovensko",
//     billing_street: "Žižkovo náměstí 1",
//     billing_city: "Nové Město nad Metují",
//     billing_zip: "549 01",
//     ico: "1532165489",
//     dic: "25114651435",
//     company: "Steam s.r.o.",
//     ic_dph: "SK154691654165",
// })
export const seed = writable(Math.floor(Math.random() * 1000000))


// Login
export const showDialogLogin = writable({show: false, type: "", data: {}})
export const showUserHeader = writable(false)

export const userData = writable(null)
updateUserData()
// const string = atob(base64)
